(function () {
    'use strict';

    angular
        .module('app')
        .factory('lockSystemForMaintenanceService', lockSystemForMaintenanceService);

    lockSystemForMaintenanceService.$inject = ['$http'];

    function lockSystemForMaintenanceService($http) {
        var service = {
            getData: getData
        };

        return service;

        function getData() { }
    }
})();